<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8px" height="8px" viewBox="0 0 8 8" version="1.1">
  <path fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" stroke="currentColor" stroke-width="0.5"  
      d="M 7.75 6.664062 L 4 1.875 L 0.257812 6.664062 L 0 6.460938 L 4 1.335938 L 8 6.460938 Z M 7.75 6.664062 " />
</svg>
